<template>
  <div class="bigbox">
  <div class="box" onclick="btn(0)">
    <div class="boxCon">
      <a href="invoice.html">
        <img src="../../../static/img/fpsc.png" alt="">
        <p>发票上传</p>
      </a>
      <a href="javascript:;">
        <img src="../../../static/img/fpzl.png" alt="">
        <p>发票整理</p>
      </a>
    </div>
  </div>
  </div>
</template>

<script>
    export default {
        name: "mask"
    }
</script>

<style scoped>
  .bigbox{
    position: relative;
  }
  .box{
    width: 100%;
    height: 100%;
    position: absolute;
    background: rgba(0,0,0,0.8);
    z-index: 2;
    display: none;
  }
  .boxCon{
    width: 2.08rem;
    height: 0.82rem;
    position: absolute;
    z-index: 3;
    bottom:29px;
    left: 83px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
  }
  .boxCon a{
    display: block;
    width: 0.58rem;
    height: 0.77rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 0.09rem;
  }
  .boxCon a img{
    width: 0.55rem;
    height: 0.55rem;
  }
</style>
